import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useState, useEffect } from "react";
import {
  deleteLesson,
  updateLesson,
  updateLessonStatus,
} from "../../services/lessons";
import { toast } from "react-toastify";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { confirmDialog } from "primereact/confirmdialog";

export const LessonViewModal = ({
  visible,
  onHide,
  lesson,
  setLesson,
  orderPopulated,
  refreshData,
  setRefreshData,
}) => {
  const [date, setDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState(30);
  const [isEditingLesson, setIsEditingLesson] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    if (lesson) {
      setDate(new Date(lesson.date));
      setStartTime(lesson.start_time);
      setDuration(lesson.duration);
    } else {
      setDate(null);
      setStartTime("");
      setDuration(30);
    }
  }, [lesson]);

  const formatDuration = (value) => {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${hours ? `${hours} hour${hours > 1 ? "s" : ""}` : ""}${
      minutes ? ` ${minutes} minute${minutes > 1 ? "s" : ""}` : ""
    }`;
  };
  function formatDate(date) {
    date = new Date(date);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const handleMarkComplete = async () => {
    // console.log(lesson.start_time);
    // console.log(typeof lesson.start_time);
    // console.log(typeof lesson.date);

    // Assuming lesson.date is in format 'YYYY-MM-DD' and lesson.start_time is in format 'HH:mm:ss'
    const lessonDateTimeString = `${formatDate(lesson.date)}T${
      lesson.start_time
    }`;
    const lessonDateTime = new Date(lessonDateTimeString);

    // Check if the lesson date has passed
    if (lessonDateTime < new Date()) {
      try {
        await updateLessonStatus(lesson.id, "completed");
        toast.success("Lesson Marked Complete");
        setTimeout(() => {
          onHide();
        }, 500);
        setRefreshData(!refreshData);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2500);
      } catch (error) {
        toast.error("Failed to mark lesson as complete");
      }
    } else {
      // Show error message
      toast.error(
        "You cannot mark a lesson as complete if the date has not passed"
      );
    }
  };

  const handleUpdateLesson = async () => {
    try {
      const updatedLesson = {
        ...lesson,
        date: formatDate(date),
        start_time: startTime,
        duration,
      };
      await updateLesson(lesson.id, updatedLesson);
      toast.success("Lesson updated successfully");
      setIsEditingLesson(false);
      setRefreshData(!refreshData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to update lesson");
    }
  };

  const handleDeleteLesson = () => {
    if (!lesson?.id) return;
    console.log("button pressed");
    confirmDialog({
      message: "Are you sure you want to delete this lesson?",
      header: "Confirm Delete",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      rejectClassName: "border-1",
      acceptLabel: "Yes, Delete",
      rejectLabel: "Cancel",
      accept: async () => {
        try {
          setIsDeleting(true);
          await deleteLesson(lesson.id); // 🔧 Uncomment once your API is ready
          toast.success("Lesson deleted successfully");
          setIsDeleting(false);
          onHide();
          setRefreshData(!refreshData);
        } catch (error) {
          setIsDeleting(false);
          toast.error("Failed to delete lesson");
        }
      },
    });
  };

  // const handleMarkComplete = async () => {
  //   const lessonDateTimeString = `${lesson.date}T${lesson.start_time}`;
  //   const lessonDateTime = new Date(lessonDateTimeString);
  //   console.log(lessonDateTime);

  //   // Check if the lesson date has passed
  //   if (lessonDateTime < new Date()) {
  //     await updateLessonStatus(lesson.id, "completed").then((res) => {
  //       toast.success("Lesson Marked Complete");
  //     });
  //   } else {
  //     // Show error message
  //     toast.error(
  //       "You cannot mark a lesson as complete if the date has not passed"
  //     );
  //   }
  // };
  // const handleMarkComplete = async () => {
  //   //handle mark complete
  //   // check if lesson date is passed
  //   if (new Date(lesson.start_time) < new Date()) {
  //     await updateLessonStatus(lesson.id, "completed");
  //   } else {
  //     //show error message
  //     alert("You cannot mark a lesson as complete if date is not passed");
  //   }
  // };
  return (
    <Dialog
      header={
        <h5 className="text-center text-primary">
          {lesson ? "Lesson Details" : "Create Lesson"}
        </h5>
      }
      visible={visible}
      onHide={() => {
        setIsDeleting(false);
        setIsEditingLesson(false);
        onHide();
      }}
      modal
      className="bg-light rounded-lg"
      style={{ minWidth: "350px", maxWidth: "100%" }}
    >
      {" "}
      <div className="p-4">
        <div className="grid justify-content-center align-items-center">
          <div className="col-12 md:col-6 ">
            <label className="font-bold mr-2">Date:</label>
            {isEditingLesson ? (
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value)}
                dateFormat="yy-mm-dd"
                className="w-full w-100"
                showIcon
              />
            ) : (
              <p className="m-0">
                {date ? date.toLocaleDateString() : "Not Set"}
              </p>
            )}
          </div>

          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Start Time:</label>
            {isEditingLesson ? (
              <InputText
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                placeholder="HH:mm:ss"
                className="w-full"
              />
            ) : (
              <p className="m-0">{startTime || "Not Set"}</p>
            )}
          </div>

          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Duration:</label>
            {isEditingLesson ? (
              <InputNumber
                value={duration}
                onValueChange={(e) => setDuration(e.value)}
                suffix=" mins"
                min={15}
                max={180}
                className="w-full"
              />
            ) : (
              <p className="m-0">{formatDuration(duration)}</p>
            )}
          </div>

          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Order No.:</label>
            <p className="m-0">{lesson?.order_id || 0}</p>
          </div>

          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Student:</label>
            <p className="m-0">{lesson?.student?.name || ""}</p>
          </div>

          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Postcode:</label>
            <p className="m-0">{lesson?.student?.postcode || ""}</p>
          </div>
          {lesson?.notes && (
            <div className="col-12">
              <label className="font-bold mr-2">Notes:</label>
              <p className="m-0">{lesson?.notes || ""}</p>
            </div>
          )}
        </div>

        <div className="flex justify-content-end gap-2 mt-4">
          {isEditingLesson ? (
            <>
              <Button
                label="Save"
                icon="pi pi-check"
                className="p-button-success"
                onClick={handleUpdateLesson}
              />
              <Button
                label="Cancel"
                icon="pi pi-times"
                className="p-button-secondary"
                onClick={() => setIsEditingLesson(false)}
              />
            </>
          ) : (
            <>
              <Button
                label="Edit Lesson"
                icon="pi pi-pencil"
                onClick={() => setIsEditingLesson(true)}
              />
              {lesson?.status !== "completed" && (
                <Button
                  label="Mark Complete"
                  icon="pi pi-check"
                  className="p-button-success"
                  onClick={handleMarkComplete}
                />
              )}
              <Button
                label="Delete"
                icon="pi pi-trash"
                className="p-button-danger"
                onClick={handleDeleteLesson}
                loading={isDeleting}
              />
              <Button
                label="Close"
                icon="pi pi-times"
                className="p-button-secondary"
                onClick={onHide}
              />
            </>
          )}
        </div>
      </div>
      {/* <div className="p-4">
        <div className="grid">
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Date:</label>
            <p className="m-0">
              {date ? date.toLocaleDateString() : "Not Set"}
            </p>
          </div>
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Start Time:</label>
            <p className="m-0">{startTime || "Not Set"}</p>
          </div>
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Duration:</label>
            <p className="m-0">{formatDuration(duration)}</p>
          </div>
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Order No.:</label>
            <p className="m-0">{lesson?.order_id || 0}</p>
          </div>
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Student:</label>
            <p className="m-0">{lesson?.student?.name || ""}</p>
          </div>
          <div className="col-12 md:col-6">
            <label className="font-bold mr-2">Postcode:</label>
            <p className="m-0">{lesson?.student?.postcode || ""}</p>
          </div>
        </div>

        <div className="flex justify-content-end gap-2 mt-4">
          <Button label="Edit Lesson" />
          {lesson?.status !== "completed" && (
            <Button
              label="Mark Complete"
              icon="pi pi-check"
              className="p-button-success"
              onClick={handleMarkComplete}
            />
          )}
          <Button
            label="Close"
            icon="pi pi-times"
            className="p-button-danger"
            onClick={onHide}
          />
        </div>
      </div> */}
      {/* <div className="container p-4">
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Date:
          </label>
          <div className="col-sm-9">
            <p className="form-control-plaintext">
              {date ? date.toLocaleDateString() : "Not Set"}
            </p>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Start Time:
          </label>
          <div className="col-sm-9">
            <p className="form-control-plaintext">{startTime || "Not Set"}</p>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Duration:
          </label>
          <div className="col-sm-9 mx-1">
            <p className="form-control-plaintext">{formatDuration(duration)}</p>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Order No.:
          </label>
          <div className="col-sm-9">
            <p className="form-control-plaintext">{lesson?.order_id || 0}</p>
          </div>
        </div>{" "}
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Student:
          </label>
          <div className="col-sm-9">
            <p className="form-control-plaintext">
              {lesson?.student?.name || ""}
            </p>
          </div>
        </div>{" "}
        <div className="form-group row">
          <label className="col-sm-3 col-form-label font-weight-bold mx-1">
            Postcode:
          </label>
          <div className="col-sm-9">
            <p className="form-control-plaintext">
              {lesson?.student?.postcode || ""}
            </p>
          </div>
        </div>
        {lesson?.status !== "completed" && (
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Mark Complete"
              icon="pi pi-check"
              className="p-button-success mr-2"
              onClick={handleMarkComplete}
            />
          </div>
        )}
        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Close"
            icon="pi pi-times"
            className="p-button-danger mr-2"
            onClick={onHide}
          />
          {/* <Button
            label="Edit"
            icon="pi pi-pencil"
            className="p-button-primary"
          /> */}
      {/* </div>
      </div> */}
    </Dialog>
  );
};
export default LessonViewModal;
